import { render, staticRenderFns } from "./UploadConnectionAttachment.vue?vue&type=template&id=2f514bcb"
import script from "./UploadConnectionAttachment.vue?vue&type=script&lang=js"
export * from "./UploadConnectionAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports